import { render, staticRenderFns } from "./NRLogin.vue?vue&type=template&id=b4d0945a&scoped=true"
import script from "./NRLogin.vue?vue&type=script&lang=ts"
export * from "./NRLogin.vue?vue&type=script&lang=ts"
import style0 from "./NRLogin.vue?vue&type=style&index=0&id=b4d0945a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d0945a",
  null
  
)

export default component.exports